import React, { Component, Fragment } from 'react'
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetPassword } from '../../actions/resetPassword';
import SimpleReactValidator from 'simple-react-validator';
import { withRouter } from 'react-router-dom';

// var loading = <img src={require('../../assets/images/loader.gif')} width={20} height={20} />;

class ResetPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            consumer_email_id: ""
        }
        this.validator = new SimpleReactValidator();
    }

    handleBack = () => {
        this.props.history.push(`/login`)
    }

    handleChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        

        if (this.validator.allValid()) {
            
            const { connection_id } = this.props;
            const options = {
                connection_id,
                consumer_email_id: this.state.consumer_email_id
            }
            this.props.resetPassword(options)
            setTimeout(() => {
                this.props.history.push(`/login`, { from: 'reset' })
            }, 500)
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {

        return (
            <Fragment>
                <section className="tab-product m-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6">
                                <Tabs className="tab-content nav-material">
                                    <TabList className="nav nav-tabs nav-material">
                                        <Tab className="nav-item" style={{ width: "50%" }}>
                                            <span className="nav-link" >
                                                <i className="icofont icofont-contacts"></i>RESET PASSWORD</span>
                                            <div className="material-border"></div>
                                        </Tab>
                                    </TabList>
                                    <TabPanel>
                                        <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmit(e)}>
                                            <div className="form-row">
                                                <div className="col-md-12" style={{ paddingBottom: 30, paddingTop: 20 }}>
                                                    <input type="text" className="form-control" id="consumer_email_id"
                                                        placeholder="Enter your email ID" value={this.state.consumer_email_id} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                                    {this.validator.message('email', this.state.consumer_email_id, 'required|email')}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 30 }}>
                                                    <div style={{ display: "flex" }}>
                                                        <div style={{ flexGrow: 5, textAlign: "center" }}>
                                                            <button type="button" className="btn btn-solid" style={{ width: "99%" }} onClick={() => this.handleBack()}>Back</button>
                                                        </div>
                                                        <div style={{ flexGrow: 5, textAlign: "center" }}>
                                                            <button type="submit" className="btn btn-solid" style={{ width: "99%" }}>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    connection_id: state.tenant.connection_id
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { resetPassword },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ResetPassword));
